import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Navigate, Outlet } from "react-router-dom";
import { isUserLoggedIn } from "../utils/helper";
import Header from '../header/banner/index'
import { Image } from "antd";
import poweredLogo from "../../src/assets/images/PoweredNew.png";

const ProtectedRoutes = (props) => {

  const auth = isUserLoggedIn();

  const navigate = useNavigate();
  const locations = useLocation();

  useEffect(() => {
    // if (auth) {
    //   const isOrganizationProfilePending = sessionStorage.getItem('isOrganizationProfilePending');

    //   if (isOrganizationProfilePending === 'true') {
    //     navigate("/partner-org", {
    //       state: { tab: locations && locations.state && locations.state.tab ? locations.state.tab : "" },
    //     });
    //   }
    // }
    if (auth && locations.pathname === '/') {
      navigate("/partner-org");
    }
  }, [locations.pathname])

  return auth ? <>
    <Header />
    <div className="mainContentBody">
      <Outlet />
    </div>
    <footer>
      <div className="footerRow">
        <div className="footerCol">
          <Image
            src={poweredLogo}
            preview={false}
            alt="Connectsu logo"
            onClick={() => window.open("https://www.connectsu.co.uk/", "_blank")}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
    </footer>
  </> : <Navigate to="/PartnerAdmin" />;
};

export default ProtectedRoutes;
